import { makeSelectors } from '@utils/css';
import { taskBreakpointsCls } from './hook.task-breakpoints.js';

const taskSelectors = makeSelectors({
  content: "task--content",
  header: "task--header",
  heading: "task--heading",
  introduction: "task--introduction",
  breakpoints: taskBreakpointsCls,
  root: "task--root"
});

export { taskSelectors };
//# sourceMappingURL=_task.selectors.js.map
